import CitySEOHead from "@/components/feature/CitySEOHead";
import HammondHeroSection from "./components/HeroSection";
import HammondStickyNav from "./components/StickyNav";
import HammondProcessingTimeSection from "./components/ProcessingTimeSection";
import HammondServicesSection from "./components/ServicesSection";
import HammondLocalAreaSection from "./components/LocalAreaSection";
import HammondTestimonialsSection from "./components/TestimonialsSection";
import HammondAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import HammondComparisonSection from "./components/ComparisonSection";
import HammondMistakesSection from "./components/MistakesSection";
import HammondHowItWorksSection from "./components/HowItWorksSection";
import HammondFAQSection, { faqs } from "./components/FAQSection";
import HammondHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import HammondFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import HammondTravelTimingSection from "./components/TravelTimingSection";
import HammondDestinationsSection from "./components/DestinationsSection";

export default function HammondPage() {
  return (
    <>
      <CitySEOHead
        city="Hammond"
        state="Louisiana"
        stateAbbr="LA"
        route="/cities/hammond"
        title="Emergency Passport Hammond, LA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Hammond, LA — as fast as 24 hours. Serving SLU students, agricultural exporters, and Tangipahoa Parish families. A+ BBB rated, registered State Dept. courier."
        geoPlacename="Hammond, Louisiana"
        geoPosition="30.5044;-90.4612"
        faqs={faqs}
        servicesSchema={[
          { name: "Emergency Passport", description: "Urgent passport processing for Hammond travelers with immediate departure needs — as fast as 24 hours for Tangipahoa Parish residents." },
          { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens in Hammond with a passport issued within the last 15 years." },
          { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance for SLU students and Hammond families." },
          { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports with DS-64 form guidance in Hammond, LA." },
          { name: "Child Passport", description: "Passport services for minors under 16 with parental consent guidance for Tangipahoa Parish families." },
          { name: "Name Change", description: "Passport correction and name change service after marriage or legal name changes for Hammond residents." },
          { name: "Second Passport", description: "Second passport service for frequent international travelers from Hammond and Southeastern Louisiana University." },
        ]}
        statePageName="Louisiana"
        statePageRoute="/states/louisiana"
      />
      <div className="font-sans">
        <HammondHeroSection />
        <HammondStickyNav />
        <HammondProcessingTimeSection />
        <HammondLocalAreaSection />
        <HammondServicesSection />
        <HammondTravelTimingSection />
        <HammondDestinationsSection />
        <HammondTestimonialsSection />
        <HammondAcceptanceFacilitiesSection />
        <HammondComparisonSection />
        <HammondMistakesSection />
        <HammondHowItWorksSection />
        <HammondFAQSection />
        <HammondHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/hammond" state="LA" />
        <HammondFinalCTA />
      </div>
    </>
  );
}